import { Route, Switch } from "react-router";

import LoginPage from "./LoginPage/Login";

import { LOGIN_ROUTES } from "./module/constants";

import PageTitle from "../../ui/PageTitle/PageTitle";

import messages from "./module/messages";

import classes from "./index.module.scss";

const Login = () => {
  return (
    <div className={classes["main-layout-login"]}>
      <PageTitle title={messages.pageTitle} />
      <Switch>
        <Route strict exact path={LOGIN_ROUTES.LOGIN} component={LoginPage} />
      </Switch>
    </div>
  );
};

export default Login;
